import React from 'react';

const Dashboard = () => {
    return (
        <div>
            <h3 style={{ marginBottom: '10px' }}>Admin Dashboard</h3>
            <p style={{ fontSize: '14px' }}>
                Welcome to the admin panel
            </p>
        </div>
    );
};

export default Dashboard;
